import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "../../hooks/useForm";
import HelpIcon from "@mui/icons-material/Help";
import { getInvoicesProps } from "../../api/getInvoices";
import { useNavigate } from "react-router-dom";
import { useToggle } from "../../hooks/useToggle";
import { mediaQueries } from "../../media-query/mediaQuery";
import { CustomModal } from "../../components/CustomModal";
import { AppContext } from "../../context/context";
import { initialDataState } from "../../App";
import { LoadingButton } from "@mui/lab";
import { formatDate } from "../../utils/dateTool";

const limit = 12;

const initialState = {
  date: formatDate(new Date()),
  rfc: "",
  webId: "",
  ticket: "",
};
const fieldValidations = {
  date: { required: true },
  rfc: {
    required: true,
  },
  webId: {
    required: true,
  },
  ticket: {
    required: true,
  },
};

export const styleItem = {
  display: "flex",
  flexDirection: "column",
  gap: 1,
};

export const MainForm = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useToggle();
  const [open2, setOpen2] = useToggle();
  const match = useMediaQuery(mediaQueries.phoneSize);
  const { inputValues, handleInputOnChange, fieldErrors } = useForm(
    initialState,
    fieldValidations
  );
  const { date, rfc, webId, ticket } = inputValues;
  const { data, setData } = useContext(AppContext);
  const { status, loading } = data;
  const [disabled, setDisabled] = useState(false);
  const handleNavigate = () => {
    navigate(`/facturar/${rfc}`);
  };

  const handleSubmit = () => {
    try {
      setData({
        ...data,
        loading: true,
      });
      getInvoicesProps({ date, rfc, webId, ticket }).then((resp) => {
        if (resp?.message?.error) {
          setData({
            ...data,
            loading: false,
            error: true,
            errorMessage: resp.message.error,
          });
        } else {
          setData({
            ...data, data: resp.data, status: resp.status, origin: {
              date, rfc, invoiceKey: webId, folio: ticket
            }
          });
        }
      });
    } catch (error) {
      setData({ ...data, loading: false, error: true });
    }
  };

  useEffect(() => {
    setData(initialDataState);
  }, []);

  useEffect(() => {
    // let timer = setTimeout(() => {
    if (data?.status === 200) {
      setData({
        ...data,
        loading: false,
      });
      handleNavigate();
    }
    // }, 2000);

    // return () => {
    //   clearTimeout(timer)
    // }
  }, [status]);

  useEffect(() => {
    if (rfc.length < limit || webId.length === 0 || ticket.length === 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [inputValues]);

  return (
    <FormControl fullWidth>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={styleItem}>
          <label style={{ color: "#fff" }}>FECHA</label>
          <TextField
            type="date"
            name="date"
            color="primary"
            value={date}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            error={fieldErrors.date ? true : false}
            helperText={fieldErrors.date || ""}
            InputProps={{
              style: {
                backgroundColor: "#fff",
              },
              inputProps: {
                max: formatDate(new Date()),
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sx={styleItem}>
          <label style={{ color: "#fff" }}>RFC-RECEPTOR</label>
          <TextField
            autoFocus={true}
            // label="RFC"
            name="rfc"
            color="primary"
            value={rfc}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            error={fieldErrors.rfc ? true : false}
            helperText={fieldErrors.rfc || ""}
            InputProps={{
              style: {
                backgroundColor: "#fff",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sx={styleItem}>
          <label style={{ color: "#fff", marginBottom: 12 }}>WEB-ID</label>
          <TextField
            // label="WEB-ID"
            name="webId"
            value={webId}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton onClick={setOpen}>
                    <HelpIcon color="primary" />
                  </IconButton>
                </InputAdornment>
              ),
              style: {
                backgroundColor: "#fff",
              },
            }}
            error={fieldErrors.webId ? true : false}
            helperText={fieldErrors.webId || ""}
          />
        </Grid>
        <Grid item xs={12} sx={styleItem}>
          <label style={{ color: "#fff", marginBottom: 12 }}>TICKET</label>
          <TextField
            // label="TICKET"
            name="ticket"
            value={ticket}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton onClick={setOpen2}>
                    <HelpIcon color="primary" />
                  </IconButton>
                </InputAdornment>
              ),
              style: {
                backgroundColor: "#fff",
              },
            }}
            error={fieldErrors.ticket ? true : false}
            helperText={fieldErrors.ticket || ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} justifyContent="space-between">
          <Button variant="unu-outlined" fullWidth>
            Limpiar
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} justifyContent="space-between">
          <LoadingButton
            variant="unu"
            onClick={handleSubmit}
            fullWidth
            loading={loading}
            disabled={disabled}
          >
            Enviar
          </LoadingButton>
        </Grid>
      </Grid>
      <CustomModal open={open} onClose={setOpen} title="Web-ID">
        <img
          src="/images/webid.jpg"
          alt="ticket"
          style={{
            width: match ? "80%" : "100%",
            maxHeight: "80vh",
          }}
        />
      </CustomModal>
      <CustomModal open={open2} onClose={setOpen2} title="Web-ID">
        <img
          src="/images/ticket.jpg"
          alt="ticket"
          style={{
            width: match ? "80%" : "100%",
            maxHeight: "80vh",
          }}
        />
      </CustomModal>
    </FormControl>
  );
};
